import EditIcon from "@mui/icons-material/Edit";
import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { type GridColDef } from "@mui/x-data-grid";

import { MailCategory } from "api/memberPortal/mailList/mailList.types";
import { colorAdapter } from "utils/color";

interface BuildMailListCategoriesColumnsParams {
  onEdit: (_category: MailCategory) => void;
}

export const buildMailListCategoriesColumns = ({
  onEdit,
}: BuildMailListCategoriesColumnsParams): GridColDef<MailCategory>[] => {
  return [
    {
      field: "color",
      headerName: "",
      width: 56,
      sortable: false,
      renderCell: ({ value }) => (
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            bgcolor: colorAdapter(value),
          }}
        />
      ),
    },
    { field: "name", headerName: "Category", flex: 1 },
    {
      field: "description",
      headerName: "Description",
      flex: 2,
      renderCell: ({ value }) => (
        <Tooltip title={value ?? ""}>
          <Typography noWrap variant="body2">
            {value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "",
      width: 100,
      renderCell: ({ row }) => (
        <IconButton
          className="row-action"
          sx={{ opacity: 0, transition: "opacity 0.2s" }}
          onClick={() => onEdit(row)}
        >
          <EditIcon />
        </IconButton>
      ),
    },
  ];
};
